import { greatCircleDistance } from './greatCircleDistance';

const getDistanceLabel = (pos1, pos2) => {
    const distanceKm = greatCircleDistance({
        lat1: pos1.lat,
        lng1: pos1.lng,

        lat2: pos2.lat, //activeMarker.point.coordinates[1],
        lng2: pos2.lng //activeMarker.point.coordinates[0]
    });

    return distanceKm > 1
        ? `${distanceKm.toFixed(0)}km`
        : `${(distanceKm * 1000).toFixed(0)}m`;
}

export default getDistanceLabel; 
